export const MAX_BYTES = 2 * 1024 * 1024 * 1024;

// iOS Safari often reports an empty type for .m4a, so the extension is a
// necessary fallback rather than a nicety.
const AUDIO_EXTENSIONS = [
  '.m4a', '.m4b', '.mp3', '.wav', '.aac', '.caf',
  '.aiff', '.aif', '.flac', '.ogg', '.opus', '.webm', '.mp4',
];

function looksLikeAudio(file) {
  if (typeof file.type === 'string' && file.type.startsWith('audio/')) return true;
  const name = String(file.name ?? '').toLowerCase();
  return AUDIO_EXTENSIONS.some((ext) => name.endsWith(ext));
}

export function validateAudioFile(file) {
  if (!file) return { ok: false, reason: 'No file selected.' };
  if (!file.size) return { ok: false, reason: 'That file is empty.' };
  if (file.size > MAX_BYTES) {
    return { ok: false, reason: 'That file is larger than 2 GB.' };
  }
  if (!looksLikeAudio(file)) {
    return { ok: false, reason: 'That is not an audio file.' };
  }
  return { ok: true };
}
